import React from 'react';
import MembershipInputUserTemplate from '../../components_membership_hotel/template/hotel/membershipInputUserTemplate';
import { getReserveList, getSenyuNenList } from '../../const';
import image_base from '../../resources/image/HakoneGardenTerrace.jpg';
import common from "../../resources/js/common/common";

class MembershipInputUser extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            // 申込条件モーダル
            membershipPopup: false,
            popupDataList: [],
            popupData: {},
            popupMessage: "",
            popupMode: "",
            popupTitle: "",
            locationInfo: props.location.state && props.location.state.locationInfo ? props.location.state.locationInfo : false,
            // 画面タイトル
            categoryLabel: "",
            // 占有日モーダル
            senyuubiPopup: false,
            shokaKenriNenList: [],
            // 「ホームFLとは」モーダル
            descHomeFlPopup: false,
            // 予約キャンセルモーダル
            membershipReservationCancelPopup: false,
            membershipPlanInfo: {},
            pathSetLoading: true,
            // コース詳細モーダル
            coursePopup: false,
            courseData: {},
            // ローディング画面表示フラグ
            loadingFlg: false,
            // 部屋選択モーダル
            roomPopup: false,
            roomData: [],
            // 部屋詳細モーダル
            roomDetailPopup: false,
            roomInfo: {},
        };
    };

    render() {
        const style = {
            base: {
                backgroundImage: `url(${image_base})`,
                backgroundAttachment: "fixed",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
            },
        }

        // お客様情報入力画面モーダル表示
        const onClickOpenPopupWindow = (mode, index) => {
            this.setState({ membershipPopup: true });
            if (mode) {
                if (mode == "dinner" || mode == "breakfast") {
                    this.setState({
                        popupMode: mode,
                        popupTitle: "レストラン",
                    });
                } else if (mode == "doiInfo") {
                    this.setState({
                        popupMode: mode,
                        popupTitle: "",
                    });
                } else if (mode == "serviceInfo") {
                    this.setState({
                        popupMode: mode,
                        popupTitle: "",
                    });
                } else if (mode == "error") {
                    this.setState({
                        popupMode: mode,
                        popupTitle: "",
                    });
                } else if (mode == "mealTime") {
                    this.setState({
                        popupMode: mode,
                        popupTitle: "時間選択",
                    });
                } else if (mode == "course") {
                    this.setState({
                        popupMode: mode,
                        popupTitle: "コース選択",
                    });
                } else if (mode == "shuttleBusTime") {
                    this.setState({
                        popupMode: mode,
                        popupTitle: "シャトルバス時間",
                    });
                } else if (mode == "riyoNinzu") {
                    this.setState({
                        popupMode: mode,
                        popupTitle: "利用人数",
                    });
                } else if (mode == "otherMenuTime") {
                    this.setState({
                        popupMode: mode,
                        popupTitle: "時間選択",
                        popupData: {
                            targetIndex: index,
                            selectTimeList: [
                                "1730",
                                "1830",
                                "1900",
                                "2000",
                            ]
                        }
                    });
                } else if (mode == "otherMenuCourse") {
                    this.setState({
                        popupMode: mode,
                        popupTitle: "コース選択",
                        popupData: {
                            targetIndex: index,
                            courseList: [
                                { courseName: "コース1", courseCd: "600" },
                                { courseName: "コース2", courseCd: "601" },
                                { courseName: "コース3", courseCd: "602" },
                                { courseName: "コース4", courseCd: "603" },
                                { courseName: "コース5", courseCd: "604" },
                            ]
                        }
                    });
                }
            }
        }

        // コース詳細ポップアップ表示
        const onClickOpenCoursePopup = (course) => {
            this.setState({
                coursePopup: true,
                courseData: course,
                
            });
        }
        
        // 部屋選択ポップアップ表示
        const onClickOpenRoomPopup = (roomList, roomIndex) => {
            this.setState({
                roomPopup: true,
                roomData: roomList,
                roomIndex: roomIndex
            });
        }

        // 部屋詳細ポップアップ表示
        const onClickOpenRoomDetailPopup = (room) => {
            this.setState({
                roomDetailPopup: true,
                roomInfo: room,
            });
        }

        // 予約確認モーダル
        const onClickOpenReservationPopupWindow = (pointKaiinId) => {
            this.setState({ membershipReservationConfPopup: true, loadingFlg: true });
            common.doPost(getReserveList, { pointKaiinId: pointKaiinId }, afterGetReserveList);
        }
        // 予約情報取得後処理
        const afterGetReserveList = (res) => {
            let data = res.data;
            if (data.resultCode == 0) {
                this.setState({ reservationConfList: res.data, });
            }
            this.setState({ loadingFlg: false });
        }

        // モーダルClose
        const onClickClosePopupWindow = () => { this.setState({ membershipPopup: false, roomPopup:false, popupMode: "" }); };
        // 予約確認モーダルを閉じる
        const onClickCloseReservationConfPopupWindow = () => { this.setState({ membershipReservationConfPopup: false }); };
        // コース詳細モーダルClose
        const onClickCloseCoursePopup = () => { this.setState({ coursePopup: false }); };
        // 部屋詳細モーダルClose
        const onClickCloseRoomDetailPopup = () => { this.setState({ roomDetailPopup: false }); };

        // popupMode変更
        const setPopupMode = (mode) => this.setState({ popupMode: mode })

        // popupMode変更
        const setPopupData = (data) => this.setState({ popupData: data })

        // popUpMessage変更
        const setPopupMessage = (message) => this.setState({ popupMessage: message })

        // categoryLabel変更
        const setCategoryLabel = (categoryLabel) => this.setState({ categoryLabel: categoryLabel })

        // プラン情報取得
        const setMembershipPlanInfo = (membershipPlanInfo) => this.setState({ membershipPlanInfo: membershipPlanInfo })

        // キャンセルモーダル
        const onClickOpenCancelPopupWindow = () => {
            this.setState({ membershipReservationCancelPopup: true });
        }
        // キャンセルモーダルClose
        const onClickCloseCancelPopupWindow = () => { this.setState({ membershipReservationCancelPopup: false }); };
        // ヘッダでパスをセット中かどうか
        const setPathSetLoading = (bool) => {
          this.setState({pathSetLoading: bool});
        }

        // 占有日モーダル
        const onClickOpenSenyuubiWindow = (keiyakuNo) => {
            common.doPost(getSenyuNenList, { keiyakuNo: keiyakuNo }, afterGetSenyuNenList);
        }

        // 「ホームFlとは」モーダル
        const onClickOpenDescriptionHomeFlWindow = () => { this.setState({ descHomeFlPopup: true }); };

        // 占有日一覧取得後処理
        const afterGetSenyuNenList = (res) => {
            const data = res.data;
            if (data.resultCode == 0) {
                this.setState({
                    senyuubiPopup: true,
                    shokaKenriNenList: data.shokaKenriNenList
                });
            } else {
                this.setState({ 
                    senyuubiPopup: true,
                    shokaKenriNenList: []
                });
            }
        }

        // 占有日モーダルを閉じる
        const onClickCloseSenyuubiPopupWindow = () => { this.setState({ senyuubiPopup: false }); };

        // 「ホームFlとは」モーダルを閉じる
        const onClickCloseDescriptionHomeFlWindow = () => { this.setState({ descHomeFlPopup: false }); };

        return (
            <div style={style.base}>
                <MembershipInputUserTemplate
                    state={this.state}
                    onClickOpenPopupWindow={onClickOpenPopupWindow}
                    setPopupMode={setPopupMode}
                    setPopupData={setPopupData}
                    setPopupMessage={setPopupMessage}
                    setCategoryLabel={setCategoryLabel}
                    setMembershipPlanInfo={setMembershipPlanInfo}
                    onClickClosePopupWindow={onClickClosePopupWindow}
                    onClickOpenReservationPopupWindow={onClickOpenReservationPopupWindow}
                    onClickCloseReservationConfPopupWindow={onClickCloseReservationConfPopupWindow}
                    onClickOpenSenyuubiWindow={onClickOpenSenyuubiWindow}
                    onClickCloseSenyuubiPopupWindow={onClickCloseSenyuubiPopupWindow}
                    onClickOpenDescriptionHomeFlWindow={onClickOpenDescriptionHomeFlWindow}
                    onClickCloseDescriptionHomeFlWindow={onClickCloseDescriptionHomeFlWindow}
                    onClickOpenCancelPopupWindow={onClickOpenCancelPopupWindow}
                    onClickCloseCancelPopupWindow={onClickCloseCancelPopupWindow}
                    onClickOpenCoursePopup={onClickOpenCoursePopup}
                    onClickCloseCoursePopup={onClickCloseCoursePopup}
                    onClickOpenRoomPopup={onClickOpenRoomPopup}
                    onClickOpenRoomDetailPopup={onClickOpenRoomDetailPopup}
                    onClickCloseRoomDetailPopup={onClickCloseRoomDetailPopup}
                    setPathSetLoading={setPathSetLoading}
                />
            </div>
        )
    }
}
export default MembershipInputUser;
